import { createContext } from 'react'

const PaymentMethodsContext = createContext()

export default PaymentMethodsContext
